import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Local from "model/patrimonio/Local";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class LocalService implements BaseServiceCadastros<Local> {
    
    pesquisar(page: Pageable,  filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/local/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {reject(err.response);
                    console.error('Error status:', err.response?.status);
                    console.error('Error details:', err.response?.data);
                })
        });
    }

    consultar(id: number) {
        return new Promise<Local>((resolve, reject): void => {
            api
                .get(`/local/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(local: Local) {
        return new Promise<Local>((resolve, reject): void => {
            api
                .post(`/local/incluir`, JSON.stringify(local))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(local: Local) {
        return new Promise<Local>((resolve, reject): void => {
            api
                .put(`/local/editar`, JSON.stringify(local))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/local/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default LocalService;